import { bankersRound } from './bankers-round';
import { formatCurrency } from './currency';
import { getOwnerSplitBase } from './owner-split-base';

export function getOwnerStatementSplitSummary<
  T extends { name: string; value: number | string | null },
>({
  lines,
  members,
  contactId,
  currency,
}: {
  lines: T[];
  members: readonly {
    contactId?: string | null;
    contact?: { id?: string | null } | null;
    split: number;
  }[];
  contactId?: string | null;
  currency: string;
}) {
  const member = contactId
    ? members.find(
        (member) => (member.contactId ?? member.contact?.id) === contactId
      )
    : undefined;
  if (!member) return lines;

  const base = getOwnerSplitBase(members);
  if (member.split === base) return lines;

  const targetName = lines.some((line) => line.name === 'Available balance')
    ? 'Available balance'
    : 'Balance end';
  const targetIndex = lines.findIndex((line) => line.name === targetName);
  const target = lines[targetIndex];
  if (!target || typeof target.value !== 'number') {
    throw new Error('Statement payable summary amount is missing.');
  }
  const share = bankersRound((target.value * member.split) / base, 0);

  return [
    ...lines.slice(0, targetIndex + 1),
    {
      name: `Owner Split (${new Intl.NumberFormat('en-US', {
        style: 'percent',
        maximumFractionDigits: 3,
      }).format(member.split / base)})`,
      text: formatCurrency(share / 100, currency, 'en-US'),
      value: share,
      type: 'field',
    },
    ...lines.slice(targetIndex + 1),
  ];
}
